/* Collection quick search: narrows the current collection (and any active filters)
   by free text, e.g. "serum" or "vitamin c". Matches title, brand, product type,
   tags and the start of the description. Title matches rank first.
   UK and US spellings match each other (moisturiser / moisturizer, ageing / aging,
   colour / color), so brand-spelt product names are still found. */
(function () {
  if (window.__tdcCollSearch) return;
  // Find the main product grid first: spotlight strips above it also use .tdc-polish
  var grid = document.querySelector('.tdc-polish ul.products[data-pages]');
  var root = grid && grid.closest('.tdc-polish');
  var inputs = Array.prototype.slice.call(document.querySelectorAll('.coll-search__input'));
  if (!root || !inputs.length) return;
  window.__tdcCollSearch = true;

  var pages = parseInt(grid.getAttribute('data-pages'), 10) || 1;
  var pagination = root.querySelector('.pagination');
  var status = document.createElement('div');
  status.className = 'coll-search__status';
  status.setAttribute('aria-live', 'polite');
  status.hidden = true;
  grid.parentNode.insertBefore(status, grid);
  var results = document.createElement('ul');
  results.className = 'products coll-search__results';
  results.hidden = true;
  grid.parentNode.insertBefore(results, grid.nextSibling);

  var index = null, loading = null, timer = null, gaTimer = null, run = 0;
  var cardCache = {};
  var MAX_RESULTS = 48;

  // Folds UK and US spellings to one form. Applied to both the search term and the
  // product text, so it only ever widens matches.
  function fold(s) {
    return s.replace(/ageing/g, 'aging')
      .replace(/is/g, 'iz')
      .replace(/ys/g, 'yz')
      .replace(/our/g, 'or')
      .replace(/tre\b/g, 'ter')
      .replace(/defence/g, 'defense')
      .replace(/grey/g, 'gray');
  }
  function norm(s) { return fold((s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')); }
  function words(term) {
    var raw = norm(term).split(/\s+/).filter(Boolean), out = [];
    raw.forEach(function (w) {
      // Single letters belong to the word before ("vitamin c", "b 5")
      if (w.length === 1 && out.length) { out[out.length - 1] += ' ' + w; return; }
      out.push((w.length > 3 && /s$/.test(w) && !/ss$/.test(w)) ? w.slice(0, -1) : w);
    });
    return out;
  }
  function score(p, ws) {
    var t = norm(p.t), y = norm(p.y), s = 0;
    ws.forEach(function (w) { s += t.indexOf(w) > -1 ? 4 : (y.indexOf(w) > -1 ? 2 : 1); });
    return s;
  }
  function handleFromCard(li) {
    var a = li.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function loadIndex() {
    if (loading) return loading;
    var params = new URLSearchParams(location.search);
    params.delete('page');
    params.set('view', 'search-index');
    loading = (async function () {
      var all = [], page = 1, total = 1;
      do {
        params.set('page', page);
        var r = await fetch(location.pathname + '?' + params.toString(), { credentials: 'same-origin' });
        var j = JSON.parse(await r.text());
        total = j.pages || 1;
        all = all.concat(j.products || []);
        page++;
      } while (page <= total && page <= 8);
      index = all.map(function (p) { p.hay = norm([p.t, p.v, p.y, p.g, p.d].join(' ')); return p; });
      return index;
    })();
    loading.catch(function () { loading = null; });
    return loading;
  }

  function setStatus(n, term, capped) {
    status.innerHTML = '';
    var text = document.createElement('span');
    if (n === 0) {
      text.textContent = 'No matches for “' + term + '”. Try another word, or clear the search.';
    } else {
      text.textContent = n + (n === 1 ? ' result' : ' results') + ' for “' + term + '”' + (capped ? ', showing the first ' + MAX_RESULTS : '');
    }
    var clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'coll-search__status-clear';
    clear.textContent = 'Clear search';
    clear.addEventListener('click', function () { setValue(''); reset(); inputs[0].focus(); });
    status.appendChild(text);
    status.appendChild(clear);
    status.hidden = false;
  }

  function reset() {
    run++;
    Array.prototype.forEach.call(grid.children, function (li) { li.hidden = false; });
    grid.hidden = false;
    results.hidden = true;
    results.innerHTML = '';
    status.hidden = true;
    if (pagination) pagination.hidden = false;
    root.classList.remove('is-searching');
  }

  function initCards() {
    try { if (window.initThemeElements) window.dispatchEvent(window.initThemeElements); } catch (e) {}
    try { if (window.initReviewWidgets) window.initReviewWidgets(); } catch (e) {}
  }

  function fetchCard(handle) {
    if (cardCache[handle]) return Promise.resolve(cardCache[handle]);
    return fetch(window.Shopify.routes.root + 'products/' + handle + '?view=card')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var start = html.indexOf('<!--[product-card]-->');
        var end = html.indexOf('<!--[/product-card]-->');
        var card = (start > -1 && end > start) ? html.slice(start + 21, end) : '';
        cardCache[handle] = card;
        return card;
      })
      .catch(function () { return ''; });
  }

  async function search(term) {
    var mine = ++run;
    root.classList.add('is-searching');
    await loadIndex();
    if (mine !== run) return;
    var ws = words(term);
    var matches = index.filter(function (p) { return ws.every(function (w) { return p.hay.indexOf(w) > -1; }); });
    matches = matches.map(function (p, i) { return { p: p, s: score(p, ws), i: i }; })
      .sort(function (a, b) { return b.s - a.s || a.i - b.i; })
      .map(function (x) { return x.p; });
    var handles = {};
    matches.forEach(function (p) { handles[p.h] = true; });

    if (pages <= 1) {
      Array.prototype.forEach.call(grid.children, function (li) {
        var h = li.classList.contains('products__product') ? handleFromCard(li) : null;
        li.hidden = !(h && handles[h]);
      });
      setStatus(matches.length, term, false);
    } else {
      grid.hidden = true;
      if (pagination) pagination.hidden = true;
      var list = matches.slice(0, MAX_RESULTS);
      setStatus(matches.length, term, matches.length > MAX_RESULTS);
      results.innerHTML = '';
      results.hidden = false;
      var html = [];
      for (var i = 0; i < list.length; i += 8) {
        var batch = await Promise.all(list.slice(i, i + 8).map(function (p) { return fetchCard(p.h); }));
        if (mine !== run) return;
        batch.forEach(function (c) { if (c) html.push('<li class="products__product">' + c + '</li>'); });
      }
      results.innerHTML = html.join('');
      initCards();
    }
    root.classList.remove('is-searching');

    clearTimeout(gaTimer);
    gaTimer = setTimeout(function () {
      if (window.dataLayer) window.dataLayer.push({ event: 'collection_search', search_term: term, results: matches.length });
    }, 1200);
  }

  function setValue(v) {
    inputs.forEach(function (i) { if (i.value !== v) i.value = v; });
    document.querySelectorAll('.coll-search__clear').forEach(function (b) { b.hidden = !v; });
  }

  inputs.forEach(function (input) {
    input.addEventListener('focus', function () { loadIndex(); }, { once: true });
    input.addEventListener('input', function () {
      var v = input.value;
      setValue(v);
      clearTimeout(timer);
      var term = v.trim();
      if (term.length < 2) { reset(); return; }
      timer = setTimeout(function () { search(term); }, 250);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
      if (e.key === 'Escape') { setValue(''); reset(); }
    });
  });
  document.querySelectorAll('.coll-search__clear').forEach(function (b) {
    b.addEventListener('click', function () { setValue(''); reset(); inputs[0].focus(); });
  });
})();
